site.mMenu = {
	init: function() {
		var $mMenu = $('#mainmenu').clone().removeAttr('class').prop('id', 'mMenu').attr('role','navigation'),
			$body = $('body');
		$('ul',$mMenu).removeAttr('id');
		$mMenu.find('#searchToggle').remove();
		$body.append($mMenu);

		var $navbar = '<a href="#mm-1" class="mmHome"><span class="sr-only">Heim</span></a>';

		$('#mMenu').mmenu({
			// options
			offCanvas: {
				position: "right"
			},
			extensions: ["theme-moya"],
			navbars: [{
				position: "top",
				content: $navbar,
			}]
		},{
			// configuration
			classNames: {
				selected:"active"
			}
		});

		var API = $("#mMenu").data( "mmenu" );

		$("#mainmenuToggle").click(function() {
			API.close();
		});

		$('.mm-page.mm-slideout').removeClass('mm-slideout');

		//var $mSearch = $('#searchForm').clone().prop('id','mSearchForm');
		//$('.mm-navbar-top','#mMenu').append($mSearch);

		$('#mMenu .mm-next').append('<span class="sr-only">Next</span>');
		$('#mMenu .mm-btn.mm-prev').append('<span class="sr-only">Prev</span>');
		$('#mSearchForm label').remove();

		site.mMenu.appendQn();
		site.mMenu.appendDivisions();
		site.mMenu.appendSearchBox();
	},

	appendQn: function() {
		var $menu = $('#mm-1 .mmLevel1', '#mMenu');
			$('.quicknav .level1:not(".hiddenMobile")').each(function() {
				var $that = $(this).clone();
				$that.appendTo($menu);
			});
	},

	appendDivisions:function() {
		var $navbar = $('.mm-navbar', '#mm-1'),
			$divisions = $('.boxText', '#divisions').clone();
		$('.mm-title',$navbar).remove();
		$divisions.removeClass('boxText').addClass('divisions');
		$divisions.appendTo($navbar);
	},

	appendSearchBox:function() {
		var $searchForm = $('#searchForm').clone().removeAttr('id').addClass('searchForm').wrap('<li class="mmSearch">').parent();
		$searchForm.find('#q').removeAttr('id').attr('id', 'mQ').attr('name', 'mQ');
		$searchForm.find('#searchSubmit').removeAttr('id').attr('id', 'mSearchSubmit');
		$searchForm.find('#elm_submit').removeAttr('id').attr('id', 'mElm_submit');
		$searchForm.find('#elm_q').removeAttr('id').attr('id', 'mElm_q');
		$searchForm.find('label').removeAttr('for').attr('for', 'mQ');
		var $mmenuLevel1 = $('#mMenu .mmLevel1');
		$searchForm.prependTo($mmenuLevel1);
	}
};

// site.inits.push('site.mMenu.init()');
